/**
 * 全局 ConfirmDialog（暗色主题，单例）
 * 使用：在任意地方调 useConfirmStore.getState().open({ title, message, onConfirm })
 */

import { create } from 'zustand'

interface ConfirmOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  danger?: boolean
  onConfirm: () => void | Promise<void>
}

interface ConfirmStore {
  open: ConfirmOptions | null
  show: (options: ConfirmOptions) => void
  close: () => void
}

export const useConfirmStore = create<ConfirmStore>((set) => ({
  open: null,
  show: (options) => set({ open: options }),
  close: () => set({ open: null }),
}))

export function ConfirmDialog() {
  const open = useConfirmStore((s) => s.open)
  const close = useConfirmStore((s) => s.close)

  if (!open) return null

  const handleConfirm = async () => {
    try {
      await open.onConfirm()
    } finally {
      close()
    }
  }

  return (
    <div
      onClick={close}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(2, 6, 23, 0.7)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          minWidth: 360,
          maxWidth: 480,
          background: '#0f172a',
          border: '1px solid #334155',
          borderRadius: 12,
          padding: 20,
          color: '#e2e8f0',
          fontFamily: 'Inter, system-ui, sans-serif',
          boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>{open.title}</div>
        <div style={{ fontSize: 13, color: '#cbd5e1', lineHeight: 1.6, marginBottom: 20 }}>{open.message}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            type="button"
            onClick={close}
            style={{
              background: 'transparent',
              border: '1px solid #334155',
              color: '#cbd5e1',
              padding: '8px 16px',
              borderRadius: 6,
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            {open.cancelText ?? '取消'}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            style={{
              background: open.danger
                ? 'linear-gradient(90deg, #ef4444, #f87171)'
                : 'linear-gradient(90deg, #6366f1, #8b5cf6)',
              border: 'none',
              color: '#fff',
              padding: '8px 16px',
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {open.confirmText ?? '确认'}
          </button>
        </div>
      </div>
    </div>
  )
}
